export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/admin',
    name: '/admin',
    component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/admin.vue'),
    children: [
      {
        path: '',
        name: '/admin/',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/admin/index.vue'),
        /* no children */
      },
      {
        path: 'ai-providers',
        name: '/admin/ai-providers',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/admin/ai-providers.vue'),
        /* no children */
      },
      {
        path: 'connectors',
        name: '/admin/connectors',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/admin/connectors.vue'),
        /* no children */
      },
      {
        path: 'graphic-templates',
        name: '/admin/graphic-templates',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/admin/graphic-templates.vue'),
        /* no children */
      },
      {
        path: 'groups',
        name: '/admin/groups',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/admin/groups.vue'),
        children: [
          {
            path: '',
            name: '/admin/groups/',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/admin/groups/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: '/admin/groups/[id]',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/admin/groups/[id].vue'),
            /* no children */
          },
          {
            path: 'distribute_permissions',
            name: '/admin/groups/distribute_permissions',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/admin/groups/distribute_permissions.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'media-assets-download-stats',
        name: '/admin/media-assets-download-stats',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/admin/media-assets-download-stats.vue'),
        /* no children */
      },
      {
        path: 'notification-enabled-stations',
        name: '/admin/notification-enabled-stations',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/admin/notification-enabled-stations.vue'),
        /* no children */
      },
      {
        path: 'okta-groups',
        name: '/admin/okta-groups',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/admin/okta-groups.vue'),
        /* no children */
      },
      {
        path: 'platforms',
        name: '/admin/platforms',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/admin/platforms.vue'),
        /* no children */
      },
      {
        path: 'roles',
        name: '/admin/roles',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/admin/roles.vue'),
        /* no children */
      },
      {
        path: 'station',
        name: '/admin/station',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/admin/station.vue'),
        children: [
          {
            path: 'add',
            name: '/admin/station/add',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/admin/station/add.vue'),
            /* no children */
          },
          {
            path: 'station_:id',
            name: '/admin/station/station_[id]',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/admin/station/station_[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'users',
        name: '/admin/users',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/admin/users.vue'),
        /* no children */
      },
      {
        path: 'webhooks',
        name: '/admin/webhooks',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/admin/webhooks.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/announcements',
    name: '/announcements',
    component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/announcements.vue'),
    /* no children */
  },
  {
    path: '/dashboard',
    name: '/dashboard',
    component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/dashboard.vue'),
    children: [
      {
        path: 'home',
        name: '/dashboard/home',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/dashboard/home.vue'),
        /* no children */
      },
      {
        path: 'pillars',
        name: '/dashboard/pillars',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/dashboard/pillars.vue'),
        /* no children */
      },
      {
        path: 'story-hub',
        name: '/dashboard/story-hub',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/dashboard/story-hub.vue'),
        /* no children */
      },
      {
        path: 'tagcloud',
        name: '/dashboard/tagcloud',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/dashboard/tagcloud.vue'),
        /* no children */
      },
      {
        path: 'whereami',
        name: '/dashboard/whereami',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/dashboard/whereami.vue'),
        /* no children */
      },
      {
        path: 'workspace_groups',
        name: '/dashboard/workspace_groups',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/dashboard/workspace_groups.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/equipment',
    name: '/equipment',
    component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/equipment.vue'),
    children: [
      {
        path: '',
        name: '/equipment/',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/equipment/index.vue'),
        /* no children */
      },
      {
        path: '_uuid',
        name: '/equipment/_uuid',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/equipment/_uuid.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/equipment/[id]',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/equipment/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/fcc-report',
    name: '/fcc-report',
    component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/fcc-report.vue'),
    /* no children */
  },
  {
    path: '/notifications',
    name: '/notifications',
    component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/notifications.vue'),
    children: [
      {
        path: 'settings',
        name: '/notifications/settings',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/notifications/settings.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/outlook-addin',
    name: '/outlook-addin',
    component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/outlook-addin.vue'),
    children: [
      {
        path: '',
        name: '/outlook-addin/',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/outlook-addin/index.vue'),
        /* no children */
      },
      {
        path: 'auth-callback',
        name: '/outlook-addin/auth-callback',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/outlook-addin/auth-callback.vue'),
        /* no children */
      },
      {
        path: 'auth-popup',
        name: '/outlook-addin/auth-popup',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/outlook-addin/auth-popup.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/pcc',
    name: '/pcc',
    component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/pcc.vue'),
    children: [
      {
        path: '',
        name: '/pcc/',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/pcc/index.vue'),
        /* no children */
      },
      {
        path: 'platforms',
        name: '/pcc/platforms',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/pcc/platforms.vue'),
        children: [
          {
            path: ':id',
            name: '/pcc/platforms/[id]',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/pcc/platforms/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'rundown',
        name: '/pcc/rundown',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/pcc/rundown.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/profile',
    name: '/profile',
    component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/profile.vue'),
    children: [
      {
        path: '',
        name: '/profile/',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/profile/index.vue'),
        /* no children */
      },
      {
        path: 'user_:user_id',
        name: '/profile/user_[user_id]',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/profile/user_[user_id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/rolodex',
    name: '/rolodex',
    component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/rolodex.vue'),
    children: [
      {
        path: '',
        name: '/rolodex/',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/rolodex/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/rundowns',
    name: '/rundowns',
    component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/rundowns.vue'),
    children: [
      {
        path: '',
        name: '/rundowns/',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/rundowns/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/search',
    name: '/search',
    component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/search.vue'),
    /* no children */
  },
  {
    path: '/sequences',
    name: '/sequences',
    component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/sequences.vue'),
    children: [
      {
        path: '',
        name: '/sequences/',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/sequences/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/sequences/[id]',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/sequences/[id].vue'),
        /* no children */
      },
      {
        path: 'old',
        name: '/sequences/old',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/sequences/old.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/stagehand',
    name: '/stagehand',
    component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand.vue'),
    children: [
      {
        path: '',
        name: '/stagehand/',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/index.vue'),
        /* no children */
      },
      {
        path: 'ai-slot-configs',
        name: '/stagehand/ai-slot-configs',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/ai-slot-configs.vue'),
        /* no children */
      },
      {
        path: 'emails',
        name: '/stagehand/emails',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/emails.vue'),
        /* no children */
      },
      {
        path: 'history',
        name: '/stagehand/history',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/history.vue'),
        /* no children */
      },
      {
        path: 'inventory',
        name: '/stagehand/inventory',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/inventory.vue'),
        children: [
          {
            path: '',
            name: '/stagehand/inventory/',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/inventory/index.vue'),
            /* no children */
          },
          {
            path: 'assets',
            name: '/stagehand/inventory/assets',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/inventory/assets.vue'),
            /* no children */
          },
          {
            path: 'checkouts',
            name: '/stagehand/inventory/checkouts',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/inventory/checkouts.vue'),
            /* no children */
          },
          {
            path: 'locations',
            name: '/stagehand/inventory/locations',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/inventory/locations.vue'),
            /* no children */
          },
          {
            path: 'reservations',
            name: '/stagehand/inventory/reservations',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/inventory/reservations.vue'),
            /* no children */
          },
          {
            path: 'tags',
            name: '/stagehand/inventory/tags',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/inventory/tags.vue'),
            /* no children */
          },
          {
            path: 'types',
            name: '/stagehand/inventory/types',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/inventory/types.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'links',
        name: '/stagehand/links',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/links.vue'),
        /* no children */
      },
      {
        path: 'main',
        name: '/stagehand/main',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/main.vue'),
        /* no children */
      },
      {
        path: 'notification-groups',
        name: '/stagehand/notification-groups',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/notification-groups.vue'),
        /* no children */
      },
      {
        path: 'setup',
        name: '/stagehand/setup',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/setup.vue'),
        children: [
          {
            path: '',
            name: '/stagehand/setup/',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/setup/index.vue'),
            /* no children */
          },
          {
            path: 'column',
            name: '/stagehand/setup/column',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/setup/column.vue'),
            /* no children */
          },
          {
            path: 'defaulttasks',
            name: '/stagehand/setup/defaulttasks',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/setup/defaulttasks.vue'),
            /* no children */
          },
          {
            path: 'formats',
            name: '/stagehand/setup/formats',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/setup/formats.vue'),
            /* no children */
          },
          {
            path: 'groups',
            name: '/stagehand/setup/groups',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/setup/groups.vue'),
            /* no children */
          },
          {
            path: 'livesources',
            name: '/stagehand/setup/livesources',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/setup/livesources.vue'),
            /* no children */
          },
          {
            path: 'livetypes',
            name: '/stagehand/setup/livetypes',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/setup/livetypes.vue'),
            /* no children */
          },
          {
            path: 'outgoing-platforms',
            name: '/stagehand/setup/outgoing-platforms',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/setup/outgoing-platforms.vue'),
            /* no children */
          },
          {
            path: 'pillars',
            name: '/stagehand/setup/pillars',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/setup/pillars.vue'),
            /* no children */
          },
          {
            path: 'platforms',
            name: '/stagehand/setup/platforms',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/setup/platforms.vue'),
            /* no children */
          },
          {
            path: 'regions',
            name: '/stagehand/setup/regions',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/setup/regions.vue'),
            /* no children */
          },
          {
            path: 'sequence-formats',
            name: '/stagehand/setup/sequence-formats',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/setup/sequence-formats.vue'),
            /* no children */
          },
          {
            path: 'source',
            name: '/stagehand/setup/source',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/setup/source.vue'),
            /* no children */
          },
          {
            path: 'splits',
            name: '/stagehand/setup/splits',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/setup/splits.vue'),
            /* no children */
          },
          {
            path: 'status',
            name: '/stagehand/setup/status',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/setup/status.vue'),
            /* no children */
          },
          {
            path: 'storytypes',
            name: '/stagehand/setup/storytypes',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/setup/storytypes.vue'),
            /* no children */
          },
          {
            path: 'summary',
            name: '/stagehand/setup/summary',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/setup/summary.vue'),
            /* no children */
          },
          {
            path: 'tags',
            name: '/stagehand/setup/tags',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/setup/tags.vue'),
            /* no children */
          },
          {
            path: 'unifiedTags',
            name: '/stagehand/setup/unifiedTags',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/setup/unifiedTags.vue'),
            /* no children */
          },
          {
            path: 'videoTags',
            name: '/stagehand/setup/videoTags',
            component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/setup/videoTags.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'system_:id',
        name: '/stagehand/system_[id]',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/system_[id].vue'),
        /* no children */
      },
      {
        path: 'tokenized-access',
        name: '/stagehand/tokenized-access',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/tokenized-access.vue'),
        /* no children */
      },
      {
        path: 'uploader',
        name: '/stagehand/uploader',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stagehand/uploader.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/stories',
    name: '/stories',
    component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stories.vue'),
    children: [
      {
        path: '',
        name: '/stories/',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stories/index.vue'),
        /* no children */
      },
      {
        path: 'assignments',
        name: '/stories/assignments',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stories/assignments.vue'),
        /* no children */
      },
      {
        path: 'calendar',
        name: '/stories/calendar',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stories/calendar.vue'),
        /* no children */
      },
      {
        path: 'mediaAssets',
        name: '/stories/mediaAssets',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stories/mediaAssets.vue'),
        /* no children */
      },
      {
        path: 'scripts',
        name: '/stories/scripts',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stories/scripts.vue'),
        /* no children */
      },
      {
        path: 'shareRequests',
        name: '/stories/shareRequests',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stories/shareRequests.vue'),
        /* no children */
      },
      {
        path: 'splits',
        name: '/stories/splits',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stories/splits.vue'),
        /* no children */
      },
      {
        path: 'story_:id',
        name: '/stories/story_[id]',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stories/story_[id].vue'),
        /* no children */
      },
      {
        path: 'storyBoard',
        name: '/stories/storyBoard',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stories/storyBoard.vue'),
        /* no children */
      },
      {
        path: 'tasks',
        name: '/stories/tasks',
        component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/stories/tasks.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/websocket-demo',
    name: '/websocket-demo',
    component: () => import('/builds/scripps/newsdesk/newsdesk/src/pages/websocket-demo.vue'),
    /* no children */
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

